import { useMemo } from "react";

const nativeBooleanAttributes = [
  'disabled', 'required', 'readonly', 'checked', 'default', 'selected', 'autofocus', 'autoplay'
];

const splitIntoWords = (input: string): string[] => {
  return input
    .split(/(?=[A-Z])|[\s\-_—]+|[^\w]+/) // Split on camelCase, spaces, hyphens, underscores, em dashes, or other non-word characters
    // .flatMap(word => word.split(/(?<=[a-zA-Z])(?=\d)|(?<=[\d])(?=[a-zA-Z])/)) // Further split between letters and numbers
    .filter(Boolean); // Remove empty strings
};

const useBuildVariantProps = (
  componentName: string, 
  variants: Record<string, string> = {},
  stateFlags: Record<string, boolean | undefined> = {},
  componentVariantOverride?: string,
) => {
  const variantProps = useMemo(() => {
    let variantString = Object.entries(variants)
      .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
      .map(([, value]) => splitIntoWords(value).join('-').toLowerCase())
      .join('-');

    if (!variantString) {
      variantString = 'default';
    }

    // Create a string representation of state flags
    const stateFlagsStrings = Object.entries(stateFlags)
      .filter(([, value]) => value === true)              // Only include true flags
      .reduce<Record<string, boolean | string | undefined>>((acc, [key, value]) => {
        if (value) {
          acc[key] = nativeBooleanAttributes.includes(key) ? true : 'true';
        }
        return acc;
      }, {})
    return {
      'component-variant': componentVariantOverride ?? `${componentName}-${variantString}`,
      ...stateFlagsStrings,
    }
  }, [
    componentName,
    variants,
    stateFlags,
    componentVariantOverride,
  ]);
  
  return variantProps;
}

export default useBuildVariantProps;